import { useHistory } from "react-router-dom";
import React, { useState, useEffect } from "react";
import axiosInstance from "../../api/axiosInstance";
import useStateRef from "react-usestateref";
import { notification } from "antd";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
// Mui meterial component import
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import "./Profile.css";
import HeaderMasterComponent from "../Header/HeaderMaster";
import FooterMaster from "../Dashboard/FooterMaster";

import alertModelTickImg from "../../assets/Images/alert.svg";
import successModelTickImg from "../../assets/Doctor_web_Icon/success.svg";
import vector from "../../assets/Doctor_web_Icon/Vector.png";
import add_icon from "../../assets/clinicIcon/Add.svg";
import EmailIcon from "../../assets/icon/EmailIcon.svg";
import WebSiteIcom from "../../assets/icon/websiteIcon.svg";
import PhoneIcon from "../../assets/icon/PhoneIcon.svg";
import LoactionIcon from "../../assets/icon/LoactionIcon.svg";
import logoutIcon from "../../assets/icon/Group 23875.svg";
import BackIcon from "../../assets/Doctor_Images/Group 31.svg";
import Card from "@mui/material/Card";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Cookies from "js-cookie";

import { HiOutlineChevronLeft, HiOutlineUser } from 'react-icons/hi';
import moment from "moment";
// import { decryptAESKey, setupKeys, encryptData, decryptData } from '../Crypto_Helpers/cryptoHelper';
// import { initEncryptionSession } from '../../encryptionSession';


function ProfileComponent() {
  let Var_History = useHistory();

  const [Var_ShowImage, setVar_ShowImage] = React.useState(false);
  const [Var_Profiledata, setVar_Profiledata, Var_Profiledata_Ref] =
    useStateRef([]);
  const [, setVar_ProfileImg, Var_ProfileImg_Ref] = useStateRef("");
  const [, setVar_SinceData, Var_SinceData_Ref] = useStateRef("");
  const [, setVar_EmailData, Var_EmailData_Ref] = useStateRef("");
  const [, setVar_WebsiteData, Var_WebsiteData_Ref] = useStateRef("");
  const [, setVar_MobileData, Var_MobileData_Ref] = useStateRef("");
  const [, setVar_AddressData, Var_AddressData_Ref] = useStateRef("");
  const [, setVar_RegNo, Var_RegNo_Ref] = useStateRef("");
  const [, setVar_Location, Var_Location_Ref] = useStateRef("");
  const [loading, setLoading] = useState(true);

  const [Var_ProfileSuccessfully, setVar_ProfileSuccessfully] = useStateRef("");
  const [Var_ShowResults, setVar_ShowResults] = React.useState(true);
  const [Var_IsShowSuccess, setVar_IsShowSuccess] = React.useState(false);
  const [Var_IsShowSuccessmodal, setVar_IsShowSuccessmodal] =
    React.useState(false);
  const [Var_IsShowDeletePostModel, setVar_IsShowDeletePostModel] =
    React.useState(false);

  // initial function call start
  useEffect(() => {
    getClinicProfile();
  }, []);
  // initial function call end

  const logoutModal = () => {
    setVar_IsShowDeletePostModel(!Var_IsShowDeletePostModel);
  };

  const logout = (path) => {
    Var_History.push(path);
  };

  const localDataClear = () => {
    Cookies.remove("LoginData");
    Cookies.remove("clinic_name");
    Cookies.remove("Clinic_id");
    Cookies.remove("clinic_vendor_type_id");
    Cookies.remove("Doctor_id");
    Cookies.remove("speciality_Id");
  };

  const handleOnClick = (path) => {
    Var_History.push("/dashboard" + path);
  };

  const uploadDocument = async (e) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("module_id", "1");
    formData.append("file", e.target.files[0]);
    formData.append("pathLocation", "PROFILE/");
    axiosInstance.post("clinic/awsS3FileUpload", formData)
      .then((response) => {
        setVar_ProfileImg(response.data.data.url);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  // Get Clinic Profile Details
  const getClinicProfile = async () => {
    setLoading(true);
    let profileGetData = {
      clinic_id: Cookies.get("clinic_id"),
    };
    axiosInstance.post("clinic/getClinicProfile", profileGetData)
      .then((response) => {
        const data = response?.data?.data?.[0] || {};
        setVar_Profiledata(response?.data?.data || []);
        setVar_ProfileImg(data.vendor_profile_path || "");
        setVar_SinceData(data.vendor_since || "");
        setVar_EmailData(data.email || "");
        setVar_WebsiteData(data.website || "");
        setVar_MobileData(data.mobile || "");
        setVar_AddressData(data.address || data.vendor_address || "");
        setVar_Location(data.vendor_location || "");
        setVar_RegNo(data.clinic_refferal_code || "");
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  // Edit Clinic Profile
  const editClinicProfile = async () => {
    if (!Var_AddressData_Ref.current) {
      notification.error({ message: "Enter Clinic Address" });
      return;
    }
    if (!Var_MobileData_Ref.current) {
      notification.error({ message: "Enter Contact Number" });
      return;
    }

    setLoading(true);
    let profileEditData = {
      clinic_id: Cookies.get("clinic_id"),
      vendor_since: Var_SinceData_Ref.current,
      mobile: Var_MobileData_Ref.current,
      email: Var_EmailData_Ref.current,
      address: Var_AddressData_Ref.current,
      website: Var_WebsiteData_Ref.current,
      file_name: "clinic_profile",
      file_path: Var_ProfileImg_Ref.current?.split("?")[0] || "",
      gender: ""
    };

    axiosInstance.put("clinic/editClinicProfile", profileEditData)
      .then((response) => {
        setVar_ProfileSuccessfully("Clinic profile updated successfully.");
        setVar_IsShowSuccess(true);
        setTimeout(() => {
          setVar_IsShowSuccess(false);
          getClinicProfile();
          handleOnClick("");
        }, 2000);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  return (
    <div>
      {loading && (
        <div className="loader_body">
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <CircularProgress />
          </Box>
        </div>
      )}

      <div>
        <div className="workinghours_content">
          <div className="max-w-6xl mx-auto space-y-8 animate-in fade-in duration-700 pb-20 pt-4">
            {/* Header Card */}
            <div className="bg-white p-6 rounded-[2rem] shadow-sm border border-gray-50 flex items-center gap-6">
              <button
                onClick={() => handleOnClick("/")}
                className="p-3 hover:bg-gray-50 rounded-2xl text-gray-400 transition-all active:scale-95 flex items-center justify-center border border-transparent hover:border-gray-100"
              >
                <HiOutlineChevronLeft size={24} />
              </button>
              <div>
                <h2 className="text-[28px] font-black text-[#1e293b] tracking-tight leading-none mb-1">Clinic Profile</h2>
                <p className="text-gray-400 text-sm font-medium italic">Manage your healthcare facility information and preferences</p>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
              {/* Left Column: Clinic Logo / Avatar & Info */}
              <div className="lg:col-span-1 space-y-8">
                <div className="bg-white p-8 rounded-[2.5rem] shadow-sm border border-gray-50 flex flex-col items-center text-center">
                  <div className="relative group mb-6">
                    <div className="w-40 h-40 rounded-[2.5rem] overflow-hidden border-4 border-teal-50 shadow-xl transition-transform duration-500 group-hover:scale-105">
                      <img
                        src={Var_ProfileImg_Ref.current || Var_Profiledata?.[0]?.vendor_profile_path || vector}
                        className="w-full h-full object-cover"
                        alt="Clinic Logo"
                      />
                    </div>
                    <label
                      htmlFor="profile-upload"
                      className="absolute -bottom-2 -right-2 w-12 h-12 bg-gray-900 text-white rounded-2xl flex items-center justify-center cursor-pointer shadow-lg hover:bg-teal-600 transition-all hover:rotate-12 active:scale-90"
                    >
                      <img src={add_icon} className="w-6 h-6 invert" alt="Upload" />
                    </label>
                    <input id="profile-upload" type="file" className="hidden" onChange={uploadDocument} />
                  </div>

                  {Var_Profiledata?.[0] && (
                    <>
                      <h3 className="text-2xl font-black text-[#1e293b] tracking-tight">{Var_Profiledata[0].vendor_name}</h3>
                      <div className="flex items-center gap-2 mt-2 bg-teal-50 px-4 py-1.5 rounded-full">
                        <div className="w-2 h-2 rounded-full bg-teal-500 animate-pulse" />
                        <span className="text-[11px] font-black text-teal-700 uppercase tracking-widest">Healthcare Facility</span>
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* Right Column: Clinic Information Forms */}
              <div className="lg:col-span-2 space-y-8">
                <div className="bg-white p-10 rounded-[3rem] shadow-sm border border-gray-50">
                  <div className="flex items-center justify-between mb-12">
                    <h4 className="text-xl font-black text-[#1e293b] tracking-tight flex items-center gap-3">
                      <div className="w-10 h-10 rounded-2xl bg-teal-50 text-teal-600 flex items-center justify-center shadow-inner">
                        <HiOutlineUser size={20} />
                      </div>
                      Clinic Information
                    </h4>
                    <div className="px-5 py-2 bg-gray-50 rounded-full border border-gray-100 italic text-gray-400 text-xs font-semibold">
                      Last synced: {moment().format('hh:mm A')}
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-8">
                    {/* Clinic Name */}
                    <div className="space-y-2.5">
                      <label className="text-[11px] font-black text-gray-400 uppercase tracking-widest ml-1">Clinic Name</label>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={Var_Profiledata?.[0]?.vendor_name || ''}
                        InputProps={{
                          readOnly: true,
                          style: { borderRadius: '1.25rem', height: '56px', background: '#fafafa' }
                        }}
                        sx={{
                          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#f1f5f9' }
                        }}
                      />
                    </div>

                    {/* Email */}
                    <div className="space-y-2.5">
                      <label className="text-[11px] font-black text-gray-400 uppercase tracking-widest ml-1">Contact Email</label>
                      <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="clinic@example.com"
                        value={Var_EmailData_Ref.current || ''}
                        InputProps={{
                          readOnly: true,
                          style: { borderRadius: '1.25rem', height: '56px', background: '#fafafa' }
                        }}
                        sx={{
                          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#f1f5f9' }
                        }}
                      />
                    </div>

                    {/* Contact Number */}
                    <div className="space-y-2.5">
                      <label className="text-[11px] font-black text-gray-400 uppercase tracking-widest ml-1">Contact Phone</label>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={Var_MobileData_Ref.current || ''}
                        onChange={(e) => setVar_MobileData(e.target.value.replace(/\D/g, ''))}
                        InputProps={{
                          style: { borderRadius: '1.25rem', height: '56px' }
                        }}
                        sx={{
                          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' }
                        }}
                      />
                    </div>

                    {/* Location / Area */}
                    <div className="space-y-2.5">
                      <label className="text-[11px] font-black text-gray-400 uppercase tracking-widest ml-1">Location / Area</label>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={Var_Location_Ref.current || Var_Profiledata?.[0]?.vendor_location || ''}
                        InputProps={{
                          readOnly: true,
                          style: { borderRadius: '1.25rem', height: '56px', background: '#fafafa' }
                        }}
                        sx={{
                          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#f1f5f9' }
                        }}
                      />
                    </div>

                    {/* Clinic Address spans full width */}
                    <div className="md:col-span-2 space-y-2.5">
                      <label className="text-[11px] font-black text-gray-400 uppercase tracking-widest ml-1">Full Clinic Address</label>
                      <TextField
                        fullWidth
                        multiline
                        rows={3}
                        variant="outlined"
                        placeholder="Complete clinic address..."
                        value={Var_AddressData_Ref.current || ""}
                        onChange={(e) => setVar_AddressData(e.target.value)}
                        sx={{
                          '& .MuiOutlinedInput-root': { borderRadius: '1.5rem', padding: '1.25rem' }
                        }}
                      />
                    </div>
                  </div>

                  <div className="mt-16 flex items-center justify-between gap-6 border-t border-gray-50 pt-10">
                    <div className="flex items-center gap-2.5 text-orange-500 bg-orange-50 px-5 py-2.5 rounded-full border border-orange-100">
                      <i className="fa fa-info-circle text-xs" />
                      <span className="text-[11px] font-black uppercase tracking-wider">Note: Clinic name & email locked by admin</span>
                    </div>
                    <button
                      onClick={editClinicProfile}
                      className="px-12 py-4 bg-gray-900 text-white font-black text-xs uppercase tracking-[0.2em] rounded-2xl transition-all shadow-xl hover:bg-teal-600 active:scale-95 flex items-center gap-3"
                    >
                      Save Changes
                      <div className="w-1.5 h-1.5 rounded-full bg-teal-400" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Success Feedback Popup */}
          {Var_IsShowSuccess && (
            <div className="fixed bottom-10 right-10 z-[9999] animate-in slide-in-from-right-full duration-500">
              <div className="bg-[#1e293b] text-white px-8 py-5 rounded-[2rem] shadow-2xl flex items-center gap-6 border border-white/10 group">
                <div className="w-12 h-12 bg-teal-500/20 rounded-2xl flex items-center justify-center border border-teal-500/30">
                  <i className="fa fa-check text-teal-400 text-xl" />
                </div>
                <div>
                  <p className="text-sm font-black tracking-tight uppercase leading-none mb-1">Update Successful</p>
                  <p className="text-[11px] text-gray-400 font-medium italic">{Var_ProfileSuccessfully}</p>
                </div>
                <div className="absolute top-0 left-0 w-full h-1 bg-teal-500/20 rounded-full overflow-hidden mt-0.5 ml-0.5">
                  <div className="h-full bg-teal-500 animate-progress" style={{ width: '100%' }} />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProfileComponent;
